import React, {createContext, useContext} from "react";

import useDialog from "../../../../hooks/useDialog";
import {useApartment} from "./ApartmentContext";
import {useFeedbackTools} from "../../../../components/FeedbackTools";

const ApartmentActionContext = createContext();
export const useApartmentAction = () => useContext(ApartmentActionContext);


export default function ApartmentActionProvider({ children}) {
    const {updateApartment} = useApartment();
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const formName = useDialog();
    const formBeds = useDialog();
    const formSofaBeds = useDialog();
    const formExtraBeds = useDialog();
    const formDescriptionIt = useDialog();
    const formDescriptionEn = useDialog();
    const formTypologyId = useDialog();
    const formCategoryId = useDialog();
    const formMq = useDialog();
    const formNumberOfBathroom = useDialog();
    const formVisible = useDialog();
    const formCinCode = useDialog();

    const handleAttributeUpdate = async (formDialog, data) => {
        formDialog.setIsLoading(true);
        try {
            await updateApartment(data);
            formDialog.close();
            showSuccessNotification("Aggiornamento effettuato")
        } catch (e) {
            showErrorNotification(e)
        }
        formDialog.setIsLoading(false);
    }

    const context = {
        formName,
        formBeds,
        formSofaBeds,
        formExtraBeds,
        formDescriptionIt,
        formDescriptionEn,
        formTypologyId,
        formCategoryId,
        formMq,
        formNumberOfBathroom,
        formVisible,
        formCinCode,
        handleAttributeUpdate,
    };

    return <ApartmentActionContext.Provider value={context}>
        {children}
    </ApartmentActionContext.Provider>
}
